import { render, staticRenderFns } from "./popNotice.vue?vue&type=template&id=debb2c24&"
import script from "./popNotice.vue?vue&type=script&lang=js&"
export * from "./popNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports